import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CacheKeys } from "../../constants/CacheKeys";
import { VsaTableColumnDefinition } from "../../constants/DataGridColumns";
import { useGetActivityFields } from "../../hooks/useActivities";
import { Activity } from "../../models/Activity";
import { ApiEndpoints } from "../../models/ApiEndpoints";
import { getActivityColumnsFromColumnOrder } from "../../services/ViewService";
import { PaginatedList } from "../list/PaginatedList";

export const ArchivedActivityList = () => {
  const { data: viewDefinition, isLoading: viewDefinitionLoading } =
    useGetActivityFields();

  const { t } = useTranslation();

  const columns = useMemo<VsaTableColumnDefinition<Activity>[]>(() => {
    if (viewDefinitionLoading || !viewDefinition) {
      return [];
    }

    return getActivityColumnsFromColumnOrder(
      viewDefinition.standardFields,
      viewDefinition.fields,
      viewDefinition.publishedFieldOrder,
      false
    );
  }, [viewDefinition, viewDefinitionLoading]);

  return (
    <PaginatedList<Activity>
      apiEndpoint={ApiEndpoints.ActivitiesCurrentArchived}
      columns={columns}
      defaultSortAscending={false}
      defaultSortColumnName={"modified"}
      searchPlaceholder={t("searchActivity")}
      cacheKey={CacheKeys.Activity.ActivityArchivedList}
      filtersEndpoint={ApiEndpoints.ActivityFilters}
      storageKey="activities:archived"
      libraryFilterScope={{ listType: "activity" }}
    />
  );
};
